import { gql } from '@apollo/client';

export class RegisterUserGQLFunction {
  // create register user
  static GET_ALL_REGISTER_USERS = gql`
    query allRegisterUsers($page: Int!, $rowsPerPage: Int!) {
      allRegisterUsers(page: $page, rowsPerPage: $rowsPerPage) {
        len
        registerUsers {
          id
          userId
          authenticator
          username
          title
          nickname
          userType
          authCode
          registerDate
        }
      }
    }
  `;

  // is email registered
  static IS_EMAIL_REGISTERED = gql`
    query isEmailRegistered($authenticator: String!) {
      isEmailRegistered(authenticator: $authenticator)
    }
  `;

  static IS_USERID_REGISTERED = gql`
    query isUserIdRegistered($userId: String!) {
      isUserIdRegistered(userId: $userId)
    }
  `;

  static GET_SEARCH_REGISTER_USERS = gql`
    query searchRegisterUsers(
      $page: Int!
      $rowsPerPage: Int!
      $searchField: String!
      $searchStr: String!
      $searchRegistered: String
    ) {
      searchRegisterUsers(
        page: $page
        rowsPerPage: $rowsPerPage
        searchField: $searchField
        searchStr: $searchStr
        searchRegistered: $searchRegistered
      ) {
        len
        registerUsers {
          id
          userId
          authenticator
          username
          nickname
          title
          userType
          authCode
          registerDate
        }
      }
    }
  `;

  static EXPORT_REGISTER_USERS = gql`
    query exportRegisterUsers($searchField: String!, $searchRegistered: String, $searchStr: String!) {
      exportRegisterUsers(searchField: $searchField, searchRegistered: $searchRegistered, searchStr: $searchStr) {
        len
        registerUsers {
          id
          userId
          authenticator
          username
          nickname
          title
          userType
          authCode
          registerDate
        }
      }
    }
  `;

  static GET_REGISTER_USER_INFO = gql`
    query registerUserInfo($id: String!) {
      registerUserInfo(id: $id) {
        id
        userId
        authenticator
        username
        title
        nickname
        userType
        authCode
        # createDate
        # modifiedDate
      }
    }
  `;

  static UPDATE_REGISTER_USER_STATE = gql`
    mutation updateRegisterUserState($id: String!, $userState: Int!) {
      updateRegisterUserState(id: $id, userState: $userState) {
        user {
          id
          userId
          authenticator
          username
          userState
        }
        err
        msg
      }
    }
  `;

  static DELETE_REGISTER_USER = gql`
    mutation removeRegisterUser($id: String!) {
      removeRegisterUser(id: $id) {
        registerUser {
          id
          userId
        }
        err
        msg
      }
    }
  `;

  static CREATE_REGISTER_USER = gql`
    mutation newRegisterUser(
      $username: String
      $userId: String!
      $authenticator: String!
      $nickname: String
      $title: String
      $userType: Int
    ) {
      newRegisterUser(
        userId: $userId
        authenticator: $authenticator
        username: $username
        nickname: $nickname
        title: $title
        userType: $userType
      ) {
        registerUser {
          id
          userId
          authenticator
          username
          nickname
          title
          authCode
          userType
        }
        err
        msg
      }
    }
  `;

  static CREATE_REGISTER_USERS_xxx = gql`
    mutation newRegisterUsers($registerUsers: [RegisterUserArg!]!) {
      registerUsers {
        id
        userId
        authenticator
        username
        nickname
        title
        userType
      }
      err
      msg
    }
  `;

  static CREATE_REGISTER_USERS = gql`
    mutation newRegisterUsers($registerUsers: [RegisterUserArg!]!) {
      newRegisterUsers(registerUsers: $registerUsers) {
        registerUsers {
          id
          userId
          authenticator
          username
          nickname
          title
          userType
        }
        err
        msg
      }
    }
  `;  

  static UPDATE_REGISTER_USER = gql`
    mutation updateRegisterUsers(
      $id: String!
      $userId: String!
      $authenticator: String!
      $username: String
      $nickname: String
      $title: String
      $userType: Int
      $authCode: String
    ) {
      updateRegisterUser(
        id: $id
        userId: $userId
        authenticator: $authenticator
        username: $username
        nickname: $nickname
        title: $title
        userType: $userType
        authCode: $authCode
      ) {
        registerUser {
          id
          userId
          authenticator
          username
          nickname
          title
          authCode
          userType
        }
        err
        msg
      }
    }
  `;

  static SEND_EMAIL_AUTH = gql`
    mutation SendEmailAuth($id: String!) {
      sendEmailAuth(id: $id)
    }
  `;
}
